<template>
  <chart-card title="Média de cupons por cliente do clube" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    cuponsPorCliente: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        fidelidade: '1',
        segmentos: this.stateFilters.segments,
      }
    },
    chartData() {
      return {
        labels: [...this.cuponsPorCliente.map((object) => object.data)],
        datasets: [
          {
            label: 'Cupons por cliente',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.cuponsPorCliente.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      getCuponsPorCliente: 'get-cupons-por-cliente',
    }),

    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.getCuponsPorCliente({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            let cupons = this.calculateCupons(data)
            this.cuponsPorCliente = helpers.agrupamentoMensal(cupons, 'NUM_CUPONS')
          })
        }

        if (this.filterType === 'semanal') {
          await this.getCuponsPorCliente({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            let cupons = this.calculateCupons(data)
            this.cuponsPorCliente = helpers.agrupamentoSemanal(cupons, 'NUM_CUPONS')
          })
        }

        if (this.filterType === 'diario') {
          await this.getCuponsPorCliente({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            let cupons = this.calculateCupons(data)
            this.cuponsPorCliente = helpers.agrupamentoDiario(cupons, 'NUM_CUPONS')
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    calculateCupons(data) {
      const dataArray = Array.isArray(data) ? data : [data]
      const calculatedCupons = dataArray.map((periodo) => {
        return {
          NUM_ANO: periodo.NUM_ANO,
          NUM_CUPONS: periodo.NUM_CUPONS / periodo.NUM_CLIENTES_ATIVOS,
          NUM_MES: periodo.NUM_MES,
          NUM_SEMANA: periodo.NUM_SEMANA,
          NUM_ANOMESDIA: periodo.NUM_ANOMESDIA,
        }
      })
      return calculatedCupons
    },
  },
}
</script>
